import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { DatePipe } from "@angular/common";
import { FormControl } from "@angular/forms";
import * as _ from "lodash";
import { Combo2Service, ExcelService, ReportService } from "../../../../services/index";
import { SalesInvoiceService } from "../../../../services/salesinvoice.service";

@Component({
  selector: "partyPendingOrdreport",
  templateUrl: "./partyPendingOrdreport.html"
})
export class partyPendingOrdreport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  typeCtrl: FormControl = new FormControl();
  orderCtrl: FormControl = new FormControl();
  isLoadMask: Promise<any>;

  loadingIndicator: boolean;
  gridOptions: any;
  seasonList: any;
  colorList= [];
  orderList = [];
  seasonfinList = [];
  backbutton: boolean;
  showIncharger: string;
  showAgent: string;
  showLine: string;
  ord_date_change: boolean = false;
  typeList = [];
  seasonyearList = [];
  menu: any;
  exceldata: any;
  totalseason_target: string;
  totalseason_order_target: string;
  date_id: any;
  year_id: any;
  seasonShow: string;
  filter = {
    fin_id: "",
    season: "",
    annual_season_id: "",
    season_id: "",
    groupby: "OrdpartyWise",
    incharger_id: "",
    from_date: "",
    to_date: "",
    ord_from_date: "",
    ord_to_date: "",
    incharger_name: "",
    line_id: "",
    party_id:'',
    style: "",
    type: "",
    ordered: "BOTH",
    param : ''
  };

  columns = [];
  toggleCol = [];
  finyearList: any;

  constructor(
    private salesInv: SalesInvoiceService,
    private combo2Service: Combo2Service,
    private reportService: ReportService,
    public datePipe: DatePipe,
    private excelService: ExcelService
  ) {
    
     this.colorList = [
    "lightcyan",
    "#3fed66",
    "lightgoldenrodyellow",
    "floralwhite",
    "#fbd4da",
    "#f2cd75",
    "lightgrey",
    "whitesmoke"
  ];
    this.typeList = ["Ordwise", "OrddesignWise"];
    this.orderList = ["ORDERED", "NON-ORDERED", "BOTH"];
    this.backbutton = false;
    this.loadingIndicator = true;
  }

  ngOnInit(): void {
    this.filter.param = this.menu.param;
    this.columns = [];
    this.finyearCombo();
    this.loadSeasonList();

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: []
    };

    this.toggleCol = Object.assign({}, this.columns);
  }

  finyearCombo() {
    this.combo2Service.finyearCombo().then((res: any) => {
      this.finyearList = res.data;
      this.finyearCtrl.setValue(res.data[0].fin_id);
      this.year_id = res.data[0].fin_id;
    });
  }
  onSelectFinyear(id) {
    this.year_id = id;
    let seasonfinList = _.filter(this.seasonList, { fin_id: id });
    this.seasonfinList = seasonfinList;
    this.seasonCtrl.setValue(
      this.seasonList[this.seasonList["length"] - 1].season_id
    );
    this.onSelectdate('ALL');
  }
  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }
    setSeasonID(){
      let season = _.filter(this.seasonList, { season_year: this.filter.season });
      this.filter.season_id = season[0]["season_id"];
      console.log(this.filter.season_id, "check sesaonnnnnnnn")

      this.onSelectdate('')
      // this.getSalesParty();
    }

  displayFn(comboType: string, id: number) {
    this.date_id = id;
    let list: any = [];
    let that = this;
    list = that.seasonList;

    if (id && list.length > 0) {
      let fitem = _.find(list, { season_id: id });
      this.seasonShow = fitem["season"];
      return fitem["season"];
    }
    return "";
  }
  loadSeasonList() {
    let that = this;
    that.reportService.getBrandNewSeason(this.filter).then(function(res) {
      that.seasonList = res;
      that.seasonyearList = res;
      that.onSelectdate('ALL');
      that.allseason();
      that.seasonCtrl.setValue(res[res["length"] - 1].season_id);
      that.partyPendingOrderDetails();
    });
  }
  addDate(){
    this.ord_date_change = true;
 }
  allseason() {
    let fin_id = parseInt(this.filter.fin_id);

    this.seasonList.forEach(() => {
      let seasonAll = {
        season: "ALL",
        season_id: this.seasonList[this.seasonList["length"] - 1].season_id + 1,
        fin_id: fin_id
      };
      if (fin_id > 0) {
        this.seasonList.push(seasonAll);
      }
      fin_id = fin_id - 1;
    });
  }
  
  onSelectdate(type) {


      let fest_id = this.date_id;
      let data = this.seasonyearList;
      let obj = data.find(o => o.season_id === this.filter.season_id);

      this.filter.from_date = obj.sales_from;
      this.filter.to_date = obj.sales_to;
      this.filter.ord_from_date = obj.order_from;
      this.filter.ord_to_date = obj.order_to;

  }
 
  applyFilter(): void {

      // this.filter.style = row.style;
      if (this.filter.groupby == "OrdWise" || this.filter.groupby == "OrddesignWise") {
         this.filter.groupby = this.filter.type;
    }

  
     

  
    this.partyPendingOrderDetails();
  }
  onCellClick(event) {
    let row = event.row;
    this.backbutton = false;
    if (this.filter.groupby == "OrdpartyWise") {
      this.filter.party_id = row.party_id;
      this.filter.groupby = "OrdstyleWise";
    }
    else if (this.filter.groupby == "OrdstyleWise") {
      this.filter.style = row.style;
      this.filter.groupby = "OrdWise";
       this.filter.type = "OrdWise"
    }

      
    this.partyPendingOrderDetails();
  }
  onbackbutton(groupby) {
    this.filter.ordered = "BOTH";
    if ( this.filter.groupby == "OrdWise" ||  this.filter.groupby == "OrddesignWise") {
      this.backbutton = true;

      this.filter.groupby = "OrdstyleWise";
      this.filter.style = "";
    }
    else if(this.filter.groupby == "OrdstyleWise"){
      this.filter.party_id = "";
         this.filter.groupby = "OrdpartyWise";
    }
  

    this.partyPendingOrderDetails();
  }
  partyPendingOrderDetails(): void {

    if (this.ord_date_change) {
      this.filter.from_date = this.filter.ord_from_date;
      this.filter.to_date = this.filter.ord_to_date;
      this.ord_date_change = false;
    }
    this.filter.ord_from_date = this.datePipe.transform(
      this.filter.ord_from_date,
      "yyyy-MM-dd"
    );
    this.filter.ord_to_date = this.datePipe.transform(
      this.filter.ord_to_date,
      "yyyy-MM-dd"
    );
    this.filter.from_date = this.datePipe.transform(
      this.filter.from_date,
      "yyyy-MM-dd"
    );
    this.filter.to_date = this.datePipe.transform(
      this.filter.to_date,
      "yyyy-MM-dd"
    );
    let params = {
      filter: JSON.stringify(this.filter)
    };

    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
      data: []
    };

    this.isLoadMask = this.salesInv
      .partyPendingOrderDetails(params)
      .then(function(res: any) {

        that.loadingIndicator = false;
        if (that.filter.groupby == 'OrddesignWise') {
          res.data.forEach((element, ind) => {
            const temp = ind % 8;
            element["background"] = that.colorList[temp];
        
          });
        }
        that.gridOptions = {
          columns: res.columns,
          data: res.data,
          loading: false
        };
       
        that.exceldata = that.getData(res.columns, res.data);
      });
  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }
  getData(columns, data) {
    let cols = columns;
    let rows = [],
      row,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno
      };
      for (let j = 1; j < clen; j++) {
        let prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  ngOnDestroy() {
    this.salesInv;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/SalesOrderReports/partyOrderReport/partyPendingOrdreport.ts